import React from 'react';

import { TermsAndConditions } from '../../../atoms';

export const PartnersTermsAndConditions: React.FC = () => {
  return <TermsAndConditions />;
};
